export const ensureProtocol = (url: string) => {
    if (!url) return url
    if (
      url.startsWith("http://") ||
      url.startsWith("https://") ||
      url.startsWith("tel:") ||
      url.startsWith("mailto:")
    ) {
      return url
    }
    return `https://${url}`
  }